import React, { useState } from 'react';
import { FormFieldsData, ModalForm } from 'framework/form';
import { useListContext } from 'framework/list';
import { ValidationSchema } from 'validation-schema-library';
import { useAuthorization } from 'framework/authorization';
import MenuItem from '@mui/material/MenuItem';
import { Modal } from 'framework/ui/ui-builder';

type TransferTimelineRecordToAnotherEntityButtonProps = {
  permissionToCheck: Nullable<string | string[]>;
  submitFormFunc: (values: FormFieldsData) => Promise<object | void>;
  children: React.ReactElement | React.ReactElement[] | React.ReactNode;
  timelineId: string;
  modalTitle: string;
  getValidationSchemaFunc?: () => Promise<ValidationSchema>;
  additionalAfterSubmit?: (response: any) => void;
};

const TransferTimelineRecordToAnotherEntityButton = ({
  permissionToCheck,
  submitFormFunc,
  timelineId,
  modalTitle,
  children,
  getValidationSchemaFunc,
  additionalAfterSubmit,
}: TransferTimelineRecordToAnotherEntityButtonProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { isGranted } = useAuthorization();
  const { deleteFromList } = useListContext();
  const closeModal = () => setModalOpen(false);

  return permissionToCheck && isGranted(permissionToCheck) ? (
    <>
      <MenuItem onClick={() => setModalOpen(true)}>Transfer</MenuItem>
      <Modal
        backdrop="static"
        isOpen={modalOpen}
        title={modalTitle}
        onToggle={closeModal}
        hasCancelButton={false}
        className="modal-content"
      >
        <ModalForm
          modalOpen={modalOpen}
          closeModal={closeModal}
          submitFormFunc={submitFormFunc}
          afterSubmit={{
            execute: response => {
              if (deleteFromList) {
                deleteFromList(timelineId);
              }
              if (additionalAfterSubmit) {
                additionalAfterSubmit(response);
              }
            },
          }}
          getValidationSchemaFunc={getValidationSchemaFunc}
        >
          {children}
        </ModalForm>
      </Modal>
    </>
  ) : null;
};

export default TransferTimelineRecordToAnotherEntityButton;
